import { Avatar, Box, Button, Grid, Group, Loader, Paper, Stack, Text, Title, useMantineTheme } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import React, { useState } from "react";
import { CONNECT_TELNYX, DISCONNECT_TELNYX, GET_ALL_PHONES, GET_ALL_TELNYXES, SAVE_TELNYX_PHONE } from "../../services/phones";
import InputField, { InputFieldTypes } from "../input_field";

export default function Telnyxes({ connectOnly = false, default: defaultSettings = false }) {
    const [items, setItems] = useState<any[]>([]);
    const [phones, setPhones] = useState<any[]>([]);
    const [data, setData] = useState<any>(null);
    const [connecting, setConnecting] = useState<any>({});
    const [loadingSave, setLoadingSave] = useState<boolean>(false);
    const [loadingItems, setLoadingItems] = useState<boolean>(false);

    const theme = useMantineTheme();

    const handleChange = (dt: any) => setData((u: any) => ({ ...u, ...dt }))

    const loadData = () => {
        setLoadingItems(true)
        GET_ALL_TELNYXES()
            .then((res) => {
                setItems(res.filter((it: any) => it.is_default === defaultSettings))
            })
            .catch(err => {
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
            .finally(() => {
                setLoadingItems(false)
            })
    }

    const loadPhones = () => {
        if (!connectOnly) {
            GET_ALL_PHONES()
                .then((res) => {
                    setPhones(res)
                })
                .catch(err => {
                    notifications.show({ title: "Ops.", message: err.message, color: 'red' })
                })
        }
    }

    const handleSave = () => {
        setLoadingSave(true)
        CONNECT_TELNYX({ ...data, default: defaultSettings })
            .then((res) => {
                loadData();
            })
            .catch(err => {
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
            .finally(() => {
                setLoadingSave(false)
            })
    }

    const handleDisconnect = () => {
        setLoadingSave(true)
        DISCONNECT_TELNYX()
            .then((res) => {
                loadData();
            })
            .catch(err => {
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
            .finally(() => {
                setLoadingSave(false)
            })
    }

    React.useEffect(() => { loadData() }, [])
    React.useEffect(() => { loadPhones() }, [])

    return <Stack>
        <Group>
            <Avatar size={40} src="/assets/telnyx.png" />
            <Title style={{ flex: 1 }} c="gray.0" order={5}>Telnyx</Title>
            {items.length > 0 && <Button
                size="sm"
                onClick={handleDisconnect}
                loading={loadingSave}
                color="red"
            >Disconnect</Button>}
        </Group>
        {
            (items.length > 0 && !connectOnly && true)
                ? <Grid>
                    {items.map(telnyx => (
                        (telnyx.availablePhones ?? []).map((tph: any) => {
                            const isConnected = phones.some(p => p.number === tph.phone_number);
                            return (
                                <Grid.Col span={{ base: 12, md: 4 }}>
                                    <Paper p="md" shadow="xs" style={{ backgroundColor: theme.colors.dark[8] }}>
                                        <Stack>
                                            <Text c="gray.0" ta="center" size="sm">{tph.phone_number}</Text>
                                            <Button
                                                size="xs"
                                                variant={isConnected ? 'filled' : "outline"}
                                                loading={connecting[tph.id]}
                                                onClick={() => {
                                                    setConnecting((c: any) => ({ ...c, [tph.id]: true }));
                                                    SAVE_TELNYX_PHONE({
                                                        type: "new",
                                                        number: tph.phone_number,
                                                        telnyx_id: telnyx.id,
                                                        phone_number_id: tph.id
                                                    })
                                                        .then(() => {
                                                            loadPhones();
                                                            loadData();
                                                            notifications.show({ message: "Phone connected", color: "green" })
                                                        })
                                                        .catch((err) => {
                                                            notifications.show({ title: "Ops.", message: err.message, color: 'red' })
                                                        })
                                                        .finally(() => {
                                                            setConnecting((c: any) => ({ ...c, [tph.id]: false }));
                                                        })
                                                }}
                                            >
                                                {isConnected ? 'Reconnect' : 'Connect'}
                                            </Button>
                                        </Stack>
                                    </Paper>
                                </Grid.Col>
                            )
                        })
                    ))}
                </Grid>
                : loadingItems
                    ? <Loader />
                    : <Stack>
                        <Group align="flex-end">
                            <Box style={{ flex: 1 }}>
                                <InputField
                                    name="api_key"
                                    value={items[0]?.api_key ?? data?.api_key}
                                    readOnly={items.length > 0}
                                    fieldType={InputFieldTypes.PASSWORD}
                                    onChange={handleChange}
                                    title="API Key"
                                    placeholder="Paste your API KEY"
                                />
                            </Box>
                            {items.length === 0 && <Button
                                disabled={
                                    ((data?.api_key ?? "").length < 10)
                                }
                                size="md"
                                onClick={handleSave}
                                loading={loadingSave}
                                color="green"
                            >Connect</Button>}
                        </Group>
                    </Stack>
        }
    </Stack>
}
